import Vue from "vue";
Vue.directive('anchor', {
    bind: function(el, binding) {
        el.onclick = function() {
            let top = document.querySelector(binding.value['target']).offsetTop;
            // let doc = document.documentElement || document.body;
            window.scroll(0, top)
        }
    }
})
Vue.directive('change-title', function(el, binding) {
    setTitle(binding.value)
})
var setTitle = function(title) {
    if (title === undefined || window.document.title === title) {
        return
    }
    document.title = title
    var mobile = navigator.userAgent.toLowerCase()
    if (/iphone|ipad|ipod/.test(mobile)) {
        var iframe = document.createElement('iframe')
        iframe.style.display = 'none'
        iframe.setAttribute('src', 'https://business.kmf.com/publicity/favicon.ico')
        var iframeCallback = function() {
            setTimeout(function() {
                iframe.removeEventListener('load', iframeCallback)
                document.body.removeChild(iframe)
            }, 0)
        }
        iframe.addEventListener('load', iframeCallback)
        document.body.appendChild(iframe)
    }
}